import { io } from 'socket.io-client';
import { config } from '../config';

console.log('config.RESERVATION_API_HOST', config.RESERVATION_API_HOST);

class SocketManager {
    static instance = null;

    constructor() {
        if (SocketManager.instance) {
            return SocketManager.instance;
        }

        this.maxRetries = 200;
        this.currentRetries = 0;
        this.connected = false;

        this.socket = io(config.RESERVATION_API_HOST, {
            autoConnect: false,
        });

        this.socket.on('connect_error', (err) => {
            console.error('Connection failed:', err);
            this.retryConnection();
        });

        this.socket.on('connect', () => {
            console.log('Connected with socket id:', this.socket.id);
            this.connected = true;
            this.currentRetries = 0;
        });

        SocketManager.instance = this;
    }

    retryConnection() {
        if (this.currentRetries < this.maxRetries) {
            this.currentRetries++;
            console.log(
                `Retrying connection... Attempt ${this.currentRetries} of ${this.maxRetries}`
            );
            setTimeout(() => {
                this.socket.connect();
            }, 10000);
        } else {
            console.error('Max retries reached, could not establish connection.');
        }
    }

    connect() {
        if (!this.connected && !this.socket.connected) {
            this.socket.connect();
        }
    }

    disconnect() {
        if (this.socket.connected) {
            this.socket.disconnect();
        }
    }

    on(event, callback) {
        this.socket.on(event, callback);
    }

    off(event, callback) {
        this.socket.off(event, callback);
    }

    emit(event, data) {
        if (this.socket.connected) {
            this.socket.emit(event, data);
        } else {
            console.log(`Socket not connected. Cannot emit '${event}'`);
        }
    }

    getSocket() {
        return this.socket;
    }
}

// ✅ Export the SINGLETON
const socketInstance = new SocketManager();
export default socketInstance;
